import React, { useEffect, useState } from 'react';
import { colors } from '../styles/colors';
import { useLocation , Link } from 'react-router-dom';
import we2Black from '../assets/we2Black.svg';

const Result = () => {
    const location = useLocation();
    const receivedData = location.state;
    const [macWrongAnswers, setMacWrongAnswers] = useState([]);
    const [windowsWrongAnswers, setWindowsWrongAnswers] = useState([]);
    const [checkIsMac, setCheckIsMac] = useState(false);
    // console.log(receivedData.toolName, 'wrongAnswers');
    // // console.log(receivedData?.score, 'score');

    // co
    useEffect(() => {
        // console.log(receivedData, 'receivedData');
        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const isWindows = navigator.platform.toUpperCase().indexOf('WIN') >= 0;
        const macWrongAnswers = [];
        const windowsWrongAnswers = [];

        receivedData.wrongAnswers.forEach((item) => {
            if (isMac) {
                setCheckIsMac(true);
                // console.log('mac');
                macWrongAnswers.push(item.CorrectShortcutMac_1);
            } else if (isWindows) {
                setCheckIsMac(false);
                // console.log('windows');
                windowsWrongAnswers.push(item.CorrectShortcutWindows);
            }
        });
        // console.log(macWrongAnswers, 'macWrongAnswers');
        // console.log(windowsWrongAnswers, 'windowsWrongAnswers');

    }, [receivedData]);

    // console.log(macWrongAnswers, 'macWrongAnswers');
    // console.log(windowsWrongAnswers, 'windowsWrongAnswers');



    return (
        <div className='mx-auto flex flex-col  items-center h-screen w-screen'
            style={{ backgroundColor: colors.darkGrey }}>
            <div>
                <h1
                    className='mt-20 tracking-wide text-2xl text-center'
                    style={{ color: colors.primaryColor }}
                >
                    Keyboard Shortcut Tester
                    <span className='text-xl  ml-6 font-light '>
                        {/* {receivedData?.file?.data[0]?.ToolName} */}
                        {receivedData?.toolName}
                    </span>
                </h1>
            </div>
            <div>
                <h1
                    className='mt-20 text-center'
                    style={{ color: colors.secondaryColor , 
                    fontSize: '92px',
                    fontStyle: 'normal',
                    fontWeight: '900',
                    lineHeight: 'normal',
                     }}
                >
                    YOU SCORED  {receivedData?.score} POINTS
                </h1>
            </div>
            <div>
                <h1
                    className='mt-16  text-3xl md:text-3xl lg:text-4xl xl:text-4xl text-center'
                    style={{
                        color: colors.primaryColor,
                        letterSpacing: '8px',

                    }}
                >
                    SHORTCUTS TO PRACTICE
                </h1>
            </div>


            <div className='flex flex-col justify-center ml-28 mt-10'>
                {receivedData.wrongAnswers && receivedData.wrongAnswers.map((item, index) => {
                    const macShortcut = checkIsMac ? `⌘${item.CorrectShortcutMac_1.replace('Cmd+', '')}` : item.CorrectShortcutWindows;

                    return (
                        <div className='flex' key={index}>
                            <div className='' style={{ color: colors.secondaryColor }}>
                                <h1>{macShortcut}</h1>
                            </div>
                            <div className='ml-16 ' style={{ color: colors.primaryColor }}>
                                <h1 className='font-light'>{item.Feature}</h1>
                            </div>
                        </div>
                    );
                })}
            </div>





            <div className="flex justify-center mx-auto my-auto gap-6">
                <div>
                    <h2 
                    
                    style={{
                        color: colors.primaryColor,
                    }} className="font-bold  text-base ">
                        <Link to='/'>TRY AGAIN</Link>
                    </h2>
                </div>
                <div>
                    <h2 style={{
                        color: colors.primaryColor,
                    }} className="text-sm font-light">You missed the above shortcuts. Copy them to a new CSV to practice more!</h2>
                </div>
            </div>
            <div style={{ position: 'absolute', bottom: 0, right: 0 }}>
                <img src={we2Black} alt="keyboard" sx={{
                    width: '156px',
                    height: '117px',
                }} />
            </div>
        </div>
    )
}

export default Result